// extracted by mini-css-extract-plugin
export default {"navbar":"NewNavbar_navbar__lqI5g","navbar__left__title":"NewNavbar_navbar__left__title__EKJ5J","navbar__right":"NewNavbar_navbar__right__lA3qd"};